import { render, staticRenderFns } from "./PlatformElderByAge.vue?vue&type=template&id=0b459806&scoped=true&"
import script from "./PlatformElderByAge.vue?vue&type=script&lang=js&"
export * from "./PlatformElderByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b459806",
  null
  
)

export default component.exports